<template>
  <CFormTextarea
    :id="String(info.part_item_id)"
    rows="3"
    placeholder="請填入文字 Please enter text"
    @change="emitContent"
    :disabled="+info.is_help"
    v-model="contentText"
    :value="value"
    style="resize: none"
  >
  </CFormTextarea>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const contentText = ref(null)
    const emitContent = () => {
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: !!contentText.value,
        value_info: !+props.info.is_help ? contentText.value : '',
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        contentText.value = newVal
        emitContent()
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      emitContent,
      contentText,
    }
  },
}
</script>
